import { CURRENT_COUNTRY } from '../../../../../../_config/constants/countries.constant';
import { constant } from '../constant/config.constant';

const normalizeAddress = (address) => {
	if (!address || typeof address !== 'string') return '';

	const parts = address
		.split(',')
		.map((part) => part.trim())
		.filter(Boolean);

	if (parts.length < 3) {
		return address;
	}

	const region = parts[0];
	const commune = parts[1];
	const street = parts.slice(2).join(', ');

	return `${street}, ${commune}, ${region}, ${CURRENT_COUNTRY}`;
};

export const geocodeAddress = (address = constant.defaultAddress) => {
	console.log('Geocoding address:', address);
	return new Promise((resolve, reject) => {
		try {
			if (!window.google?.maps?.Geocoder) {
				reject(new Error('Google Maps no está disponible'));
				return;
			}

			const normalizedAddress = normalizeAddress(address);
			console.log('address original:', address);
			console.log('address normalizado:', normalizedAddress);

			const geocoder = new window.google.maps.Geocoder();

			geocoder.geocode({ address: normalizedAddress }, (results, status) => {

				if (status !== 'OK' || !results?.length) {
					reject(new Error('No se pudo geocodificar la dirección'));
					return;
				}

				const exactResult = results.find((result) => result?.partial_match !== true);

				if (!exactResult) {
					reject(new Error('Dirección inexistente'));
					return;
				}

				const location = exactResult.geometry.location;

				resolve({
					lat: Number(location.lat().toFixed(6)),
					lng: Number(location.lng().toFixed(6)),
					formattedAddress: exactResult.formatted_address,
					addressComponents: exactResult.address_components || [],
					partialMatch: !!exactResult.partial_match,
					rawResult: exactResult,
				});
			});
		} catch (error) {
			reject(error);
		}
	});
};
